import { MessageSquare, InstagramIcon, TwitterIcon, MessageCircle, Mail, Heart, MapPin } from "lucide-react";
import { cn } from "@/lib/utils";

const brandLocationTags = [
  "SKF Bearings in Wankaner", "SKF Bearings in Morbi",
  "FAG Bearings in Wankaner", "FAG Bearings in Morbi",
  "NBC Bearings in Wankaner", "NBC Bearings in Morbi",
  "NSK Bearings in Wankaner", "NSK Bearings in Morbi",
  "Timken Bearings in Wankaner", "Timken Bearings in Morbi",
  "NTN Bearings in Wankaner", "NTN Bearings in Morbi",
  "Koyo Bearings in Wankaner", "Koyo Bearings in Morbi",
  "INA Bearings in Wankaner", "INA Bearings in Morbi",
  "Nachi Bearings in Wankaner", "Nachi Bearings in Morbi",
  "RHP Bearings in Wankaner", "RHP Bearings in Morbi",
  "THK Guides in Wankaner", "THK Guides in Morbi",
  "Hiwin Bearings in Wankaner", "Hiwin Bearings in Morbi",
  "Kluber Grease in Wankaner", "Kluber Grease in Morbi",
];

const serviceAreas = [
  "Wankaner", "Morbi", "Dhuva", "Rajkot", "Tankara", "Than", "Paddhari", "Halvad", "Surendranagar", "Jamnagar", "Ahmedabad", "Gujarat"
];

export function Footer() {
  return (
    <footer className="bg-muted relative overflow-hidden" role="contentinfo">
      <div className="container py-12 md:py-16 relative z-10">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {/* Resources */}
          <div>
            <h3 className="font-bold text-lg mb-4">Resources</h3>
            <ul className="space-y-2">
              <li>
                <a href="#about" className="text-muted-foreground hover:text-foreground transition-colors">
                  About Us
                </a>
              </li>
              <li>
                <a href="#categories" className="text-muted-foreground hover:text-foreground transition-colors">
                  Product Categories
                </a>
              </li>
              <li>
                <a href="#partners" className="text-muted-foreground hover:text-foreground transition-colors">
                  Brand Partners
                </a>
              </li>
              <li>
                <a href="#customization" className="text-muted-foreground hover:text-foreground transition-colors">
                  Customization Options
                </a>
              </li>
            </ul>
          </div>

          {/* Products */}
          <div>
            <h3 className="font-bold text-lg mb-4">Products</h3>
            <ul className="space-y-2">
              <li>
                <a href="#categories" className="text-muted-foreground hover:text-foreground transition-colors">
                  Ball Bearings
                </a>
              </li>
              <li>
                <a href="#categories" className="text-muted-foreground hover:text-foreground transition-colors">
                  Roller Bearings
                </a>
              </li>
              <li>
                <a href="#categories" className="text-muted-foreground hover:text-foreground transition-colors">
                  Linear Bearings
                </a>
              </li>
              <li>
                <a href="#categories" className="text-muted-foreground hover:text-foreground transition-colors">
                  Oil Seals & Greases
                </a>
              </li>
              <li>
                <a href="#contact" className="text-muted-foreground hover:text-foreground transition-colors">
                  Custom Solutions
                </a>
              </li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h3 className="font-bold text-lg mb-4">Connect With Us</h3>
            <div className="flex space-x-4 mb-4">
              <a href="https://twitter.com/avonbearings" target="_blank" rel="noopener noreferrer" aria-label="Follow Avon Bearings on X (Twitter)" className="text-muted-foreground hover:text-foreground transition-colors">
                <TwitterIcon className="h-5 w-5" />
              </a>
              <a href="https://www.instagram.com/avonbearings" target="_blank" rel="noopener noreferrer" aria-label="Follow Avon Bearings on Instagram" className="text-muted-foreground hover:text-foreground transition-colors">
                <InstagramIcon className="h-5 w-5" />
              </a>
              <a href="https://wa.me/919664585193" target="_blank" rel="noopener noreferrer" aria-label="Contact Avon Bearings on WhatsApp" className="text-muted-foreground hover:text-foreground transition-colors">
                <MessageCircle className="h-5 w-5" />
              </a>
              <a href="https://maps.app.goo.gl/aP9CUGeJo7cCCuvE8" target="_blank" rel="noopener noreferrer" aria-label="View Avon Bearings location on Google Maps" className="text-muted-foreground hover:text-foreground transition-colors">
                <MapPin className="h-5 w-5" />
              </a>
            </div>
            <address className="text-sm text-muted-foreground not-italic">
              <strong className="text-foreground">AVON BEARINGS</strong><br />
              3, JADESHWAR CHAMBER,<br />
              8-A National Highway,<br />
              Wankaner, Dist MORBI-363622,<br />
              Gujarat, India.<br />
              <a href="tel:+919664585193" className="hover:text-foreground transition-colors">+91 96645 85193</a><br />
              <a href="mailto:avonbearingswkr@gmail.com" className="hover:text-foreground transition-colors">avonbearingswkr@gmail.com</a>
            </address>
          </div>
        </div>

        {/* Local SEO Brand Tags - crawlable keyword strips (Hidden from view) */}
        <div className="sr-only">
          <h4>Authorized Dealer — Brands Available in Wankaner & Morbi</h4>
          <div>
            {brandLocationTags.map((tag) => (
              <span key={tag}>{tag}</span>
            ))}
          </div>
        </div>

        {/* Service Areas (Hidden from view for SEO) */}
        <div className="sr-only">
          <h4>Service Areas</h4>
          <ul>
            {serviceAreas.map((area) => (
              <li key={area}>
                <a href="#contact">
                  Bearings in {area}
                </a>
              </li>
            ))}
          </ul>
        </div>

        {/* Address & Local SEO bottom line (Hidden from view) */}
        <div className="sr-only">
          <p>
            Best Bearing Shop in Wankaner | Bearing Dealer in Morbi | Bearing Shop Near Dhuva | SKF, FAG, NBC, Timken, NTN, NSK, Koyo Bearings | Serving Dhuva, Tankara, Than, Paddhari, Halvad | 3, Jadeshwar Chamber, 8-A National Highway, Wankaner, Dist Morbi-363622, Gujarat, India | +91 96645 85193
          </p>
        </div>

        <div className="mt-8">
          <p className="text-sm text-muted-foreground text-center">
            © {new Date().getFullYear()} AVON BEARINGS. All rights reserved.
          </p>
          <p className="text-sm text-muted-foreground text-center mt-2">
            Made with <Heart className="inline-block h-4 w-4 text-red-500" /> by{" "}
            <a
              href="https://elitedesign-io.vercel.app/"
              target="_blank"
              rel="noopener noreferrer"
              className="text-primary hover:underline"
            >
              Elite Design.io
            </a>
          </p>
        </div>
      </div>

      {/* Oversized branding element - decorative only */}
      <div className="absolute bottom-0 left-0 right-0 overflow-hidden opacity-20 pointer-events-none" aria-hidden="true">
        <div className="max-w-[2000px] mx-auto px-4">
          <div className="text-[8vw] md:text-[10vw] lg:text-[12vw] xl:text-[12vw] 2xl:text-[9vw] font-black tracking-tighter leading-none whitespace-nowrap avon-gradient-text pb-4 text-center">
            AVON BEARINGS
          </div>
        </div>
      </div>
    </footer>
  );
}
